(function () {
  'use strict';

  var PROVINCE_CODE = 'speakout.province_code';
  var PROVINCE_NAME = 'speakout.province_name';

  function SpeakOutPlanGrid(sectionEl) {
    this.section = sectionEl;
    this.sectionId = sectionEl.dataset.sectionId;
    this.noProvinceMessage = sectionEl.dataset.noProvinceMessage || 'Please select your province to add a plan.';
    this.modal = document.getElementById('speakout-province-modal-' + this.sectionId);
    this._pendingVariantId = null;
    this._pendingBtn = null;
    this._bindEvents();
  }

  SpeakOutPlanGrid.prototype._bindEvents = function () {
    var self = this;

    this.section.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-plan-add]');
      if (addBtn) {
        e.preventDefault();
        self._handleAddNow(addBtn);
        return;
      }

      var provBtn = e.target.closest('[data-province-code]');
      if (provBtn) {
        e.preventDefault();
        self._selectProvince(provBtn);
        return;
      }

      if (e.target.closest('[data-close-modal]') || e.target === self.modal) {
        self._closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.modal && !self.modal.hidden) {
        self._closeModal();
      }
    });
  };

  // docs/plans/imei-province-e911-plan.md S5 — "Add now" never writes to the
  // cart from this card: that skipped the phone-compatibility check
  // entirely (a real gap the client's brief calls out, section 3.4).
  // It persists the province, same as before, then hands off to the plan
  // PDP itself, which is the only place a plan is actually added to the
  // cart, landing on the IMEI step.
  SpeakOutPlanGrid.prototype._handleAddNow = function (btn) {
    var card = btn.closest('[data-variant-id]');
    if (!card) return;

    var provinceCode = card.dataset.provinceCode || sessionStorage.getItem(PROVINCE_CODE);

    // Marker SQU-10/SQU-11: on the plans collection page the province is no
    // longer asked for up front — every plan costs the same in every
    // province we serve, and the plan PDP this hands off to already captures
    // the province for the 911 fee before anything reaches the cart. Other
    // templates keep the gate (data-province-required defaults to true), so
    // nothing outside the plans template changes.
    var provinceRequired = this.section.dataset.provinceRequired !== 'false';

    if (!provinceCode && provinceRequired) {
      this._showNoProvinceNotice(btn);
      this._scrollToProvinceGate();
      return;
    }

    // Persist product-level province so the plan PDP prefills the same
    // value whatever other flow stored in sessionStorage.
    if (card.dataset.provinceCode) {
      sessionStorage.setItem(PROVINCE_CODE, card.dataset.provinceCode);
    }

    this._goToPlanPage(card, btn);
  };

  SpeakOutPlanGrid.prototype._goToPlanPage = function (card, btn) {
    var planUrl = card.dataset.planUrl;
    if (!planUrl) {
      this._showError(btn);
      return;
    }
    this._setLoading(btn, true);
    window.location.assign(planUrl + (planUrl.indexOf('?') === -1 ? '?' : '&') + 'step=imei');
  };

  SpeakOutPlanGrid.prototype._scrollToProvinceGate = function () {
    var gate = document.querySelector('[data-speakout-province-gate]');
    if (gate) gate.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  SpeakOutPlanGrid.prototype._showNoProvinceNotice = function (btn) {
    var self = this;
    var card = btn ? btn.closest('.speakout-plan-card') : null;
    if (!card) return;

    var notice = card.querySelector('.speakout-plan-card__error');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'speakout-plan-card__error';
      notice.setAttribute('role', 'alert');
      var body = card.querySelector('.speakout-plan-card__body');
      if (body) body.appendChild(notice);
    }
    notice.textContent = self.noProvinceMessage;
  };

  SpeakOutPlanGrid.prototype._selectProvince = function (btn) {
    var code = btn.dataset.provinceCode;
    var name = btn.dataset.provinceName;

    sessionStorage.setItem(PROVINCE_CODE, code);
    sessionStorage.setItem(PROVINCE_NAME, name);

    this._closeModal();

    if (this._pendingBtn) {
      var pendingBtn = this._pendingBtn;
      this._pendingVariantId = null;
      this._pendingBtn = null;
      // Re-enter the normal flow: province is now stored, so this hands
      // off to the plan PDP.
      this._handleAddNow(pendingBtn);
    }
  };

  SpeakOutPlanGrid.prototype._openModal = function () {
    if (!this.modal) return;
    this.modal.hidden = false;
    document.body.classList.add('overflow-hidden');
    var closeBtn = this.modal.querySelector('.speakout-plan-grid__modal-close');
    if (closeBtn) closeBtn.focus();
  };

  SpeakOutPlanGrid.prototype._closeModal = function () {
    if (!this.modal) return;
    this.modal.hidden = true;
    document.body.classList.remove('overflow-hidden');
    var returnFocus = this._pendingBtn;
    if (returnFocus) returnFocus.focus();
  };

  SpeakOutPlanGrid.prototype._setLoading = function (btn, loading) {
    var textEl = btn.querySelector('.speakout-plan-card__cta-text');
    var spinnerEl = btn.querySelector('.speakout-plan-card__cta-loading');
    btn.disabled = loading;
    btn.setAttribute('aria-busy', String(loading));
    if (textEl) textEl.hidden = loading;
    if (spinnerEl) spinnerEl.hidden = !loading;
  };

  SpeakOutPlanGrid.prototype._showError = function (btn, message) {
    var card = btn ? btn.closest('.speakout-plan-card') : null;
    if (!card) return;
    var notice = card.querySelector('.speakout-plan-card__error');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'speakout-plan-card__error';
      notice.setAttribute('role', 'alert');
      var body = card.querySelector('.speakout-plan-card__body');
      if (body) body.appendChild(notice);
    }
    notice.textContent = message || btn.dataset.errorMessage || 'Something went wrong. Please try again.';
  };

  function init(sectionEl) {
    if (sectionEl._speakoutPlanGrid) return;
    sectionEl._speakoutPlanGrid = new SpeakOutPlanGrid(sectionEl);
  }

  document.querySelectorAll('[id^="speakout-plan-grid-"]').forEach(init);

  // Any link that opens /collections/<handle> lands scrolled to the grid
  // bound to that collection when that grid is not the page's first one
  // (8 Sep client request: "See annual plans" must land on the annual
  // section, and the rule holds for every such button/link). An explicit
  // #hash in the URL wins over this.
  (function () {
    if (window.location.hash) return;
    var match = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
    if (!match) return;
    var grids = Array.prototype.slice.call(
      document.querySelectorAll('[id^="speakout-plan-grid-"][data-collection-handle]')
    );
    var target = null;
    grids.forEach(function (grid, index) {
      if (index > 0 && grid.dataset.collectionHandle === match[1]) target = grid;
    });
    if (!target) return;
    setTimeout(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 150);
  })();

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[id^="speakout-plan-grid-"]');
    if (section) init(section);
  });
})();
